import { Injectable, signal } from '@angular/core';

/** Tracks whether the modern iframe overlay owns shell presentation (e.g. document title). */
@Injectable({ providedIn: 'root' })
export class ModernFramePresentationService {
  readonly #modernActive = signal(false);

  readonly isModernActive = this.#modernActive.asReadonly();

  setModernActive(active: boolean): void {
    this.#modernActive.set(active);
  }
}
